<script setup>
import { ref } from 'vue';
import { Head, usePage } from '@inertiajs/vue3';
import { useInterval } from '@vueuse/core';
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const page = usePage();

const baseRemainingTime = page.props.remainingTime;

const countdown = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

const updateCountdown = (timeSpent) => {
  let remainingTime = baseRemainingTime - timeSpent;

  if (remainingTime < 0) {
    window.location.reload();

    return;
  }

  countdown.value.days = Math.floor(remainingTime / (24 * 60 * 60));
  remainingTime = remainingTime % (24 * 60 * 60);
  countdown.value.hours = Math.floor(remainingTime / (60 * 60));
  remainingTime = remainingTime % (60 * 60);
  countdown.value.minutes = Math.floor(remainingTime / 60);
  countdown.value.seconds = Math.floor(remainingTime % 60);
};

updateCountdown(0);

useInterval(
    1000,
    { callback: updateCountdown }
);

const blockClasses = 'text-center';
const digitClasses = 'text-5xl sm:text-7xl text-primary font-semibold';
const labelClasses = 'mt-2 font-semibold text-gray-400';
</script>

<template>
  <Head title="Chèques cadeaux"/>

  <div class="min-h-full">
    <header class="pt-8 pb-4 flex justify-center">
      <ApplicationLogo class="w-72"/>
    </header>

    <main
        class="relative max-w-2xl px-4 py-4 sm:px-6 lg:px-8 flex flex-col justify-center sm:items-center mx-auto size-full">
      <div class="text-center pb-4 px-4 sm:px-6 lg:px-8 size-full">
        <h1 class="text-xl sm:text-2xl text-primary uppercase font-semibold">
          Commande de chèques cadeaux en promotion
        </h1>
      </div>

      <div class="mt-8 flex flex-col text-center">
        <p>
          La vente de chèques cadeaux ouvre dans :
        </p>

        <div class="max-w-72 sm:max-w-none mt-8 mx-auto px-4 grid grid-cols-4 items-center gap-5 sm:gap-10 ">
          <div :class="blockClasses">
            <div :class="digitClasses">{{ countdown.days }}</div>
            <div :class="labelClasses">jours</div>
          </div>

          <div :class="blockClasses">
            <div :class="digitClasses">{{ countdown.hours }}</div>
            <div :class="labelClasses">heures</div>
          </div>

          <div :class="blockClasses">
            <div :class="digitClasses">{{ countdown.minutes }}</div>
            <div :class="labelClasses">minutes</div>
          </div>

          <div :class="blockClasses">
            <div :class="digitClasses">{{ countdown.seconds }}</div>
            <div :class="labelClasses">secondes</div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>